import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3691426"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-posts-counter" }
const _hoisted_2 = { class: "frisbuy-posts-counter__description" }
const _hoisted_3 = { class: "frisbuy-posts-counter__progress-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, " Вы посмотрели " + _toDisplayString(_ctx.currentPostsCount) + " из " + _toDisplayString(_ctx.allPostsCount) + " образов ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "frisbuy-posts-counter__progress-filler",
        style: _normalizeStyle({
            'margin-left': `-${100 - _ctx.percentOfProgress}%`,
          })
      }, null, 4)
    ])
  ]))
}